import { Type } from 'class-transformer';

export class TimeSubmissionResultDto {
    entryId: number;

    @Type(() => Date)
    date: Date;

    description: string;
    billingCode: string;
    isBillable: string;
    duration: number;
    amount: number;
    reimbursableAmount: number;
    notes: string;
}
